(function () {
  const initSlider = (section) => {
    const sliderEl = section.querySelector('.nb-testimonials__slider');
    const paginationEl = section.querySelector('.nb-testimonials__pagination');

    if (!sliderEl) return null;

    const autoplayDelay = parseInt(sliderEl.dataset.swiperAutoplay, 10) || 0;
    const prefersReducedMotion = window.matchMedia('(prefers-reduced-motion: reduce)').matches;
    const autoplayOn = autoplayDelay > 0 && !prefersReducedMotion;

    return new Swiper(sliderEl, {
      slidesPerView: 1,
      spaceBetween: 20,
      speed: 600,
      loop: autoplayOn,
      autoplay: autoplayOn
        ? {
            delay: autoplayDelay,
            pauseOnMouseEnter: true,
            disableOnInteraction: false,
          }
        : false,
      pagination: paginationEl
        ? { el: paginationEl, clickable: true }
        : false,
    });
  };

  const initCursor = (section, swiper) => {
    const containerEl = section.querySelector('.nb-testimonials__slider-container');
    const cursorEl = section.querySelector('.nb-testimonials__cursor');

    if (!containerEl || !cursorEl || !swiper) return;

    let currentX = 0;
    let currentY = 0;
    let targetX = 0;
    let targetY = 0;
    const easingFactor = 0.19;
    let isAnimating = false;
    let isCursorInit = false;

    const animateCursor = () => {
      isAnimating = true;
      currentX += (targetX - currentX) * easingFactor;
      currentY += (targetY - currentY) * easingFactor;
      cursorEl.style.left = `${currentX}px`;
      cursorEl.style.top = `${currentY}px`;

      if (Math.abs(targetX - currentX) > 0.1 || Math.abs(targetY - currentY) > 0.1) {
        requestAnimationFrame(animateCursor);
      } else {
        isAnimating = false;
      }
    };

    const handleMouseMove = (e) => {
      const rect = containerEl.getBoundingClientRect();
      const cursorRect = cursorEl.getBoundingClientRect();
      const centerX = rect.left + rect.width / 2;

      if (e.clientX < centerX) {
        cursorEl.classList.add('prev');
        cursorEl.classList.remove('next');
      } else {
        cursorEl.classList.remove('prev');
        cursorEl.classList.add('next');
      }

      targetX = e.clientX - rect.left - cursorRect.width / 2;
      targetY = e.clientY - rect.top - cursorRect.height / 2;

      if (!isAnimating) animateCursor();
    };

    const handleMouseEnter = (e) => {
      const rect = containerEl.getBoundingClientRect();
      const cursorRect = cursorEl.getBoundingClientRect();

      targetX = currentX = e.clientX - rect.left - cursorRect.width / 2;
      targetY = currentY = e.clientY - rect.top - cursorRect.height / 2;
      cursorEl.style.left = `${currentX}px`;
      cursorEl.style.top = `${currentY}px`;

      containerEl.classList.add('cursor-active');
    };

    const handleMouseLeave = () => {
      containerEl.classList.remove('cursor-active');
    };

    const handleClick = (e) => {
      const rect = containerEl.getBoundingClientRect();
      const centerX = rect.left + rect.width / 2;

      if (e.clientX < centerX) {
        swiper.slidePrev();
      } else {
        swiper.slideNext();
      }
    };

    const bindCursor = () => {
      if (window.innerWidth >= 1200 && window.matchMedia('(pointer:fine)').matches) {
        if (!isCursorInit) {
          containerEl.addEventListener('mouseenter', handleMouseEnter);
          containerEl.addEventListener('mousemove', handleMouseMove);
          containerEl.addEventListener('mouseleave', handleMouseLeave);
          containerEl.addEventListener('click', handleClick);
          isCursorInit = true;
        }
      } else {
        if (isCursorInit) {
          containerEl.removeEventListener('mouseenter', handleMouseEnter);
          containerEl.removeEventListener('mousemove', handleMouseMove);
          containerEl.removeEventListener('mouseleave', handleMouseLeave);
          containerEl.removeEventListener('click', handleClick);
          isCursorInit = false;
        }
      }
    };

    bindCursor();
    window.addEventListener('resize', bindCursor);
  };

  const currentSection =
    document.currentScript.parentElement.closest('.nb-testimonials-section') ||
    document.currentScript.parentElement;

  initCursor(currentSection, initSlider(currentSection));

  document.addEventListener('shopify:section:load', function (event) {
    if (event.target.classList.contains('nb-testimonials-section')) {
      initCursor(event.target, initSlider(event.target));
    }
  });
})();
